import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_SUPPRESSION_ARME_RECUPERER,
    CONTEXT_SUPPRESSION_ARME_VALIDER,
} from '../../../constants/apiUrls.constants';

const demanderSuppression = combineReducers({
    reponse: APIReducer.bind(null, CONTEXT_SUPPRESSION_ARME_VALIDER),
    recuperer: APIReducer.bind(null, CONTEXT_SUPPRESSION_ARME_RECUPERER),
});

export default demanderSuppression;
